import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Config } from './config';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export interface CollectionEdited {
    customerId: number;
}

@Injectable()
export class CollectService {
    public collectionEdited = new BehaviorSubject<CollectionEdited>(null);
    constructor(public http: HttpClient) {}

    public collectLocation(
        customerId: number,
        locationId: number,
        startDate?: string,
        endDate?: string,
    ): Observable<void> {
        const url =
            Config.serviceUrl +
            Config.urls.collections +
            customerId +
            `&locationId=${locationId}&start=${startDate}&end=${endDate}`;

        return this.http.post<void>(url, '').pipe(
            tap(() => this.collectionEdited.next({ customerId }))
        );
    }

    public collectAllLocation(customerId: number, locationId: number): Observable<void> {
        const url = Config.serviceUrl + Config.urls.collections + customerId + `&locationId=${locationId}`;

        return this.http.post<void>(url, '').pipe(
            tap(() => this.collectionEdited.next({ customerId }))
        );
    }

    public collectAllSchedule(customerId: number): Observable<void> {
        const url = Config.serviceUrl + Config.urls.collectall + `?customerId=${customerId}`;

        return this.http.post<void>(url, '').pipe(
            tap(() => this.collectionEdited.next({ customerId }))
        );
    }
}
